const INSURANCE_THRESHOLDS = {
  TWD: { base_threshold: 3000, premium_threshold: 6000, baseFee: 40, fixedFee: 10, precision: 0 },
  USD: { base_threshold: 100, premium_threshold: 200, baseFee: 2, fixedFee: 1, precision: 2 },
  CNY: { base_threshold: 750, premium_threshold: 1500, baseFee: 10, fixedFee: 3, precision: 2 },
  HKD: { base_threshold: 750, premium_threshold: 1500, baseFee: 10, fixedFee: 3, precision: 2 },
  JPY: { base_threshold: 15000, premium_threshold: 30000, baseFee: 200, fixedFee: 50, precision: 0 },
}

const roundTo = (value, precision) => {
  const factor = 10 ** precision;
  return Math.round(value * factor) / factor;
}

export const CalculateInsuranceFee = (price, country, currency = "TWD") => {
  const config = INSURANCE_THRESHOLDS[currency] || INSURANCE_THRESHOLDS.TWD;
  const specialCountries = ["CN", "HK", "MO"];

  if (specialCountries.includes(country)) {
    if (price > config.base_threshold && price <= config.premium_threshold) return config.fixedFee;
    if (price > config.premium_threshold) return roundTo(Math.max(price * 0.005, config.baseFee), config.precision);
  }

  if (price > config.base_threshold) return roundTo(Math.max(price * 0.01, config.baseFee), config.precision);
  return 0;
}
